import { DEFAULT_THEME } from '@/lib/consts';

export type Theme = 'light' | 'dark';

export function isTheme(value: any): value is Theme {
  return typeof value === 'string' && ['light', 'dark'].includes(value);
}

export function getUserThemePreference(defaultTheme: Theme = DEFAULT_THEME): Theme {
  if (typeof window === 'undefined') return defaultTheme;
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
}

export const invertTheme = (t: Theme) => (t === 'light' ? 'dark' : 'light');
